import styled from 'styled-components'
import { Form } from '../../../CoForm'

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;

  .MuiFormControl-root {
    max-width: 100px;
  }
`
